import { render, staticRenderFns } from "./shoplist.vue?vue&type=template&id=30ac5dd3&scoped=true&"
import script from "./shoplist.vue?vue&type=script&lang=js&"
export * from "./shoplist.vue?vue&type=script&lang=js&"
import style0 from "./shoplist.vue?vue&type=style&index=0&id=30ac5dd3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ac5dd3",
  null
  
)

export default component.exports